const LSD_SERVICE_DEPENDENCY = [
  { value: 0, text: 'Dependent' },
  { value: 1, text: 'Independent' },
  { value: 2, text: 'Semi Independent' }
];

type LSD_SERVICE_DEPENDENCY = typeof LSD_SERVICE_DEPENDENCY;

export default LSD_SERVICE_DEPENDENCY;
